const pictograms = {
  cloud: {
    graphics: [
      {
        name: "circle",
        svgProps: {
          fill: "neutral-900",
          height: 225,
          style: { position: "absolute" },
          width: 225,
        },
      },
      {
        name: "circle",
        svgProps: {
          fill: "neutral-900",
          height: 220,
          style: { position: "absolute" },
          width: 220,
          x: 110,
        },
      },
      {
        name: "circle",
        svgProps: {
          fill: "neutral-900",
          height: 180,
          style: { position: "absolute" },
          width: 180,
          x: 250,
          y: -1,
        },
      },
      {
        name: "circle",
        svgProps: {
          fill: "neutral-900",
          height: 170,
          style: { position: "absolute" },
          width: 170,
          x: 270,
          y: 80,
        },
      },
      {
        name: "circle",
        svgProps: {
          fill: "neutral-900",
          height: 210,
          style: { position: "absolute" },
          width: 210,
          x: 120,
          y: 30,
        },
      },
      {
        name: "circle",
        svgProps: {
          fill: "neutral-900",
          height: 160,
          style: { position: "absolute" },
          width: 160,
          x: 60,
          y: 120,
        },
      },
    ],
    style: {
      filter: "drop-shadow(5px 5px 8px rgba(0, 0, 0, 0.5))",
      height: "280px",
      width: "440px",
    },
  },
  jetstream: {
    graphics: [
      {
        name: "airplane",
        svgProps: {
          fill: "primary-500",
          height: 50,
          rotateZ: "270deg",
          width: 50,
        },
      },
      {
        name: "dashedLine",
        svgElementProps: {
          animate: { strokeDashoffset: -90 },
          stroke: "primary-500",
          strokeDashoffset: 0,
          transition: {
            duration: 0.75,
            ease: "linear",
            repeat: Infinity,
          },
        },
        svgProps: {
          position: "absolute",
          rotateZ: "90deg",
          x: -94,
          y: 88,
        },
      },
      {
        name: "dashedLine",
        svgElementProps: {
          animate: { strokeDashoffset: -78 },
          stroke: "primary-500",
          strokeDashoffset: 12,
          transition: {
            duration: 0.75,
            ease: "linear",
            repeat: Infinity,
          },
        },
        svgProps: {
          position: "absolute",
          rotateZ: "90deg",
          x: -79,
          y: 88,
        },
      },
      {
        name: "dashedLine",
        svgElementProps: {
          animate: { strokeDashoffset: -48 },
          stroke: "primary-500",
          strokeDashoffset: 42,
          transition: {
            duration: 0.75,
            ease: "linear",
            repeat: Infinity,
          },
        },
        svgProps: {
          position: "absolute",
          rotateZ: "90deg",
          x: -63,
          y: 88,
        },
      },
      {
        name: "dashedLine",
        svgElementProps: {
          animate: { strokeDashoffset: -42 },
          stroke: "primary-500",
          strokeDashoffset: 48,
          transition: {
            duration: 0.75,
            ease: "linear",
            repeat: Infinity,
          },
        },
        svgProps: {
          position: "absolute",
          rotateZ: "90deg",
          x: -48,
          y: 88,
        },
      },
    ],
    style: { height: "130px", width: "50px" },
  },
  wave: {
    graphics: [
      {
        name: "line",
        svgElementProps: {
          animate: {
            d: ["M5,5 L5,35", "M5,5 L5,5", "M5,5 L5,35"],
            height: [40, 0, 40],
          },
          d: "M5,5 L5,5",
          height: 0,
          stroke: "primary-600",
          transition: { duration: 1.5, repeat: Infinity },
          width: 10,
        },
        svgProps: {
          animate: {
            viewBox: ["0 0 10 40", "0 0 10 0", "0 0 10 40"],
            y: [55, 55, 55],
          },
          height: 40,
          style: { position: "absolute", width: "10px" },
          transition: { duration: 1.5, repeat: Infinity },
          viewBox: "0 0 10 50",
          width: 10,
          y: 55,
        },
      },
      {
        name: "line",
        svgElementProps: {
          animate: {
            d: ["M5,5 L5,95", "M5,5 L5,25", "M5,5 L5,95"],
            height: [100, 30, 100],
          },
          d: "M5,5 L5,25",
          height: 0,
          stroke: "primary-600",
          transition: { duration: 1.5, repeat: Infinity },
          width: 10,
        },
        svgProps: {
          animate: {
            height: [100, 50, 100],
            viewBox: ["0 0 10 100", "0 0 10 50", "0 0 10 100"],
            y: [25, 65, 25],
          },
          height: 50,
          style: { position: "absolute", width: "10px" },
          transition: { duration: 1.5, repeat: Infinity },
          viewBox: "0 0 10 50",
          width: 10,
          x: 20,
          y: 25,
        },
      },
      {
        name: "line",
        svgElementProps: {
          animate: {
            d: ["M5,5 L5,145", "M5,5 L5,35", "M5,5 L5,145"],
            height: [150, 50, 150],
          },
          d: "M5,5 L5,35",
          height: 0,
          stroke: "primary-700",
          transition: { duration: 1.5, repeat: Infinity },
          width: 10,
        },
        svgProps: {
          animate: {
            height: [150, 50, 150],
            viewBox: ["0 0 10 150", "0 0 10 50", "0 0 10 150"],
            y: [0, 60, 0],
          },
          height: 50,
          style: { position: "absolute", width: "10px" },
          transition: { duration: 1.5, repeat: Infinity },
          viewBox: "0 0 10 50",
          width: 10,
          x: 40,
          y: 0,
        },
      },
      {
        name: "line",
        svgElementProps: {
          animate: {
            d: ["M5,5 L5,75", "M5,5 L5,20", "M5,5 L5,75"],
            height: [80, 20, 80],
          },
          d: "M5,5 L5,20",
          height: 0,
          stroke: "primary-500",
          transition: { duration: 1.5, repeat: Infinity },
          width: 10,
        },
        svgProps: {
          animate: {
            height: [80, 50, 80],
            viewBox: ["0 0 10 80", "0 0 10 50", "0 0 10 80"],
            y: [35, 65, 35],
          },
          height: 50,
          style: { position: "absolute", width: "10px" },
          transition: { duration: 1.5, repeat: Infinity },
          viewBox: "0 0 10 50",
          width: 10,
          x: 60,
          y: 50,
        },
      },
      {
        name: "line",
        svgElementProps: {
          animate: {
            d: ["M5,5 L5,115", "M5,5 L5,30", "M5,5 L5,115"],
            height: [120, 0, 120],
          },
          d: "M5,5 L5,30",
          height: 0,
          stroke: "primary-600",
          transition: { duration: 1.5, repeat: Infinity },
          width: 10,
        },
        svgProps: {
          animate: {
            height: [120, 50, 120],
            viewBox: ["0 0 10 120", "0 0 10 50", "0 0 10 120"],
            y: [15, 60, 15],
          },
          height: 50,
          style: { position: "absolute", width: "10px" },
          transition: { duration: 1.5, repeat: Infinity },
          viewBox: "0 0 10 50",
          width: 10,
          x: 80,
          y: 15,
        },
      },
      {
        name: "line",
        svgElementProps: {
          animate: {
            d: ["M5,5 L5,45", "M5,5 L5,10", "M5,5 L5,45"],
            height: [50, 0, 50],
          },
          d: "M5,5 L5,10",
          height: 0,
          stroke: "primary-600",
          transition: { duration: 1.5, repeat: Infinity },
          width: 10,
        },
        svgProps: {
          animate: {
            viewBox: ["0 0 10 50", "0 0 10 0", "0 0 10 50"],
            y: [50, 45, 50],
          },
          height: 50,
          style: { position: "absolute", width: "10px" },
          transition: { duration: 1.5, repeat: Infinity },
          viewBox: "0 0 10 50",
          width: 10,
          x: 100,
          y: 50,
        },
      },
    ],
    style: { height: "150px", position: "relative", width: "110px" },
  },
};

export { pictograms };
